import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

export default function RsvpHelp({ id, label, text }) {
  return (
    <OverlayTrigger placement="top" trigger={["hover", "focus"]} overlay={<Tooltip id={id}>{text}</Tooltip>}>
      <button type="button" className="btn p-0 border-0 text-muted ms-2 align-baseline" aria-label={`Ajuda: ${label}`}>
        <FontAwesomeIcon icon={faCircleInfo} aria-hidden="true" />
      </button>
    </OverlayTrigger>
  );
}
